var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScatterIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#FF2E00",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 41.5,
    r: 5.5,
    fill: "#FF2E00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 23.5,
    r: 3.5,
    fill: "#FF2E00",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 28.5,
    r: 3.5,
    fill: "#FF2E00",
    fillOpacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 16,
    r: 4,
    fill: "#FF2E00",
    fillOpacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 4,
    fill: "#FF2E00",
    fillOpacity: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 41,
    r: 4,
    fill: "#FF2E00",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterIconRed);
export default __webpack_public_path__ + "static/media/scatter_icon_red.d87eba8ca097abde56d11aeb25496356.svg";
export { ForwardRef as ReactComponent };